import * as React from 'react'

import { observer } from 'mobx-react'

import ConfirmDialog from '~/client/src/shared/components/ConfirmDialog/ConfirmDialog'
import StatusBadge from '~/client/src/shared/components/StatusBadge/StatusBadge'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { IStatusItem } from '~/client/src/shared/utils/permitStatusUtils'

interface IProps {
  isOpen: boolean
  selectedItem: IStatusItem | null
  permitCount: number
  onConfirm: () => void
  onCancel: () => void
}

const ConfirmNotificationStatusUpdateDialog: React.FC<IProps> = ({
  isOpen,
  selectedItem,
  permitCount,
  onConfirm,
  onCancel,
}) => {
  if (!selectedItem) return null

  const confirmButtonText =
    Localization.translator.updateXWorkflows(permitCount)

  return (
    <ConfirmDialog
      isOpen={isOpen}
      onCancelClicked={onCancel}
      onDoneClicked={onConfirm}
      doneTitle={confirmButtonText}
    >
      <div className="tw:text-sm tw:text-foreground">
        {Localization.translator.youAreGoingToUpdate}{' '}
        <span className="tw:text-sm tw:font-semibold">
          {Localization.translator.status}
        </span>{' '}
        {Localization.translator._to}
        <StatusBadge
          status={selectedItem.status}
          isLate={false}
          showDot={false}
          workflowStepLevel={selectedItem.workflowStepLevel}
        />
        {Localization.translator._for}{' '}
        <span className="tw:text-sm tw:font-semibold">
          {Localization.translator.xWorkflows(permitCount)}
        </span>
      </div>
    </ConfirmDialog>
  )
}

export default observer(ConfirmNotificationStatusUpdateDialog)
